import { ChatEvent } from './client-chat-thread.model';
import { chatThreadAdapter } from './client-chat-thread-state.service';

export interface StoryChatPayload {
  snapshotMessages: ChatEvent[];
  deltaAppendMessages: ChatEvent[];
}

/**
 * Extracts and normalizes chat messages from a StoryService step payload.
 *
 * Handles two StoryService payload envelope shapes:
 *   - Namespaced: `{ snapshot: { 'client.chat.thread': { messages: [] } }, delta: { 'client.chat.thread': { append: [] } } }`
 *   - Flat:       `{ snapshot: { chat: { messages: [] } }, delta: { chat: { append: [] } } }`
 *
 * Also handles legacy flat array for backward compat.
 *
 * Returns empty arrays for missing/invalid data.
 */
export function extractStoryChatPayload(raw: unknown): StoryChatPayload {
  if (!raw || typeof raw !== 'object') {
    return { snapshotMessages: [], deltaAppendMessages: [] };
  }

  const obj = raw as Record<string, unknown>;

  // StoryService payload envelope shape: { snapshot: {...}, delta: {...} }
  if ('snapshot' in obj || 'delta' in obj) {
    const snapshot = obj['snapshot'] as Record<string, unknown> | undefined;
    const delta = obj['delta'] as Record<string, unknown> | undefined;

    // Try namespaced key first ('client.chat.thread'), then fall back to flat 'chat' key
    // (different demos use different payload schemas)
    const snapshotThread = (snapshot?.['client.chat.thread'] ?? snapshot?.['chat']) as Record<string, unknown> | undefined;
    const deltaThread = (delta?.['client.chat.thread'] ?? delta?.['chat']) as Record<string, unknown> | undefined;

    const snapshotMessages = chatThreadAdapter(snapshotThread?.['messages']);
    const deltaAppendMessages = chatThreadAdapter(deltaThread?.['append']);

    console.log('[StoryChatAdapter] extracted', { snapshotCount: snapshotMessages.length, deltaCount: deltaAppendMessages.length, snapshotThreadKeys: snapshotThread ? Object.keys(snapshotThread) : null, deltaThreadKeys: deltaThread ? Object.keys(deltaThread) : null });

    return { snapshotMessages, deltaAppendMessages };
  }

  // Legacy flat array — treat as snapshot only, no delta
  if (Array.isArray(raw)) {
    return { snapshotMessages: chatThreadAdapter(raw), deltaAppendMessages: [] };
  }

  return { snapshotMessages: [], deltaAppendMessages: [] };
}
